export const BOOKINGS_FETCH_REQUEST = "BOOKINGS_FETCH_REQUEST";
export const BOOKINGS_FETCH_SUCCESS = "BOOKINGS_FETCH_SUCCESS";
export const BOOKINGS_FETCH_FAIL = "BOOKINGS_FETCH_FAIL";

export const BOOKING_CANCEL_REQUEST = "BOOKING_CANCEL_REQUEST";
export const BOOKING_CANCEL_SUCCESS = "BOOKING_CANCEL_SUCCESS";
export const BOOKING_CANCEL_FAIL = "BOOKING_CANCEL_FAIL";

export const BOOKINGS_CLEAR_ERROR = "BOOKINGS_CLEAR_ERROR";
